'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002eregex$002e$002dPattern$0024 from "./java.util.regex.-Pattern$.js";
import * as $j_scala$002eutil$002e$002dLeft from "./scala.util.-Left.js";
import * as $j_scala$002eutil$002e$002dRight from "./scala.util.-Right.js";
var $p;
/** @constructor */
function $c_Lsamples_package$package$ExtraString$$anon$1() {
}
export { $c_Lsamples_package$package$ExtraString$$anon$1 as $c_Lsamples_package$package$ExtraString$$anon$1 };
$p = $c_Lsamples_package$package$ExtraString$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_package$package$ExtraString$$anon$1;
/** @constructor */
function $h_Lsamples_package$package$ExtraString$$anon$1() {
}
export { $h_Lsamples_package$package$ExtraString$$anon$1 as $h_Lsamples_package$package$ExtraString$$anon$1 };
$h_Lsamples_package$package$ExtraString$$anon$1.prototype = $p;
$p.jx = (function(str) {
  var x1 = $j_java$002eutil$002eregex$002e$002dPattern$0024.$m_ju_regex_Pattern$().VI("^[a-fA-F0-9]+$", str);
  if (x1) {
    return new $j_scala$002eutil$002e$002dRight.$c_s_util_Right(str);
  }
  if ((!x1)) {
    return new $j_scala$002eutil$002e$002dLeft.$c_s_util_Left("expected hexadecimal string (just for demo)");
  }
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x1);
});
var $d_Lsamples_package$package$ExtraString$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_package$package$ExtraString$$anon$1, "samples.package$package$ExtraString$$anon$1", ({
  rk: 1,
  bn: 1
}));
export { $d_Lsamples_package$package$ExtraString$$anon$1 as $d_Lsamples_package$package$ExtraString$$anon$1 };
